<template>
  <div class="component-debugger" v-if="data && data.debugEnable.value">
    <div class="c-toolbar q-py-xs q-px-xs q-gutter-sm">
      <q-btn color="primary" :icon="ICONS.filters" class="c-btn" dense size="13px" unelevated>
        <q-menu
            class="component-debugger-menu"
            anchor="bottom end"
            self="top right"
            persistent
            ref="menuRef"
            v-model="showing"
            :class="{
              '--ready': showingReady
            }"
        >
          <q-btn
              class="c-closer"
              :icon="ICONS.close"
              dense
              outline
              size="12px"
              @click="showing = false"
          />
          <div class="q-py-sm q-px-md" style="margin-top: -20px;">
            <div class="row no-wrap q-col-gutter-md">
              <div class="col-16" v-if="data.fields.value && data.fields.value.length > 0">

                <div class="q-mb-xs s-font-sm text-weight-medium">Отладка:</div>
                <div class="row q-col-gutter-sm">
                  <q-field
                      v-for="(item, index) in data.fields.value"
                      :key="item.label || index"
                      :label="item.label"
                      outline
                      dense
                      size="13px"
                      readonly
                      outlined
                      stack-label
                      color="black"
                      :class="item.width || 'col-24'"
                  >
                    <JsonViewer
                        :value="toValue(item.value)"
                        v-if="item.json"
                        v-bind="item.jsonParams"
                        class="c-json q-py-sm"
                    />
                    <div v-else v-html="toValue(item.value)"></div>
                  </q-field>
                </div>
              </div>
              <div class="col-8" v-if="data.actions">
                <div class="q-mb-xs s-font-sm text-weight-medium">Действия:</div>
                <div class="q-gutter-sm">
                  <q-btn
                      v-for="(item, index) in data.actions.value"
                      :key="item.label || index"
                      :label="item.label || ''"
                      outline
                      color="primary"
                      dense
                      size="13px"
                      @click="onMenuItemClick(item)"
                      class="leading-tiny"
                  />
                </div>
              </div>
            </div>
          </div>
        </q-menu>
      </q-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICONS } from "@/assets/icons";
import { DebugComponentProps } from "@/core/composable/useDebugComponent";
import { useDebugStore } from "@/core/store/debug";
import { MenuItem } from "@/gql/gen";
import { storeToRefs } from "pinia";
import { onMounted, ref, toRefs, toValue, watch } from "vue";
import { JsonViewer } from "vue3-json-viewer";

const debugStore = useDebugStore()

const {debugOptions} = storeToRefs(debugStore)

const props = withDefaults(defineProps<DebugComponentProps>(), {})

const {data} = toRefs(props)

const {} = props

const menuRef = ref()

const onMenuItemClick = (item: Partial<MenuItem>) => {
  item.onClick()
  showing.value = false
}

onMounted(() => {

})

const showing = ref(false)
const showingReady = ref(false)
const showingReadyTimeout = ref()

watch(showing, () => {
  if (showing.value) {
    showingReadyTimeout.value = setTimeout(() => {
      showingReady.value = showing.value
    }, 350)
  } else {
    showingReady.value = false
    clearTimeout(showingReadyTimeout.value)
  }
})

</script>
<style lang="scss" scoped>
.component-debugger {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100000;
}

.c-toolbar {
  visibility: hidden;
  pointer-events: none;
}

.c-btn {
  font-size: 13px;
}

.c-toolbar {
}

.c-json {
  background-color: transparent;

  :deep(.jv-code) {
    padding: 0;
  }
}

.c-closer {
  //position: absolute;
  left: 100%;
  top: 10px;
  position: sticky;
  margin-right: 10px;
}

</style>

<style lang="scss">
.com {
  &:hover {
    .component-debugger {
      .c-toolbar {
        visibility: visible !important;
        pointer-events: all !important;
      }
    }
  }
}

.component-debugger-menu {
  min-width: 200px;
  max-width: 600px;

  &:not(.--ready) {
    visibility: hidden !important;
  }
}
</style>
